import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/**
 * @class Task
 * UI Detection Task Class
 */
var Task = /*#__PURE__*/function () {
  function Task(log) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Task);

    this.log = log;
    this.opts = _objectSpread({
      detectionInterval: 15000,
      detectionThreshold: 1500
    }, opts);
    this.timer = 0;
    this.frame = undefined;
    this.visible = true;
  }

  _createClass(Task, [{
    key: "start",
    value: function start() {
      var detectionInterval = this.opts.detectionInterval;
      this.timer = setInterval(this.runJob.bind(this), detectionInterval);
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this.timer);
    }
  }, {
    key: "toggleVisible",
    value: function toggleVisible(status) {
      this.visible = status;
      if (status) this.start();else this.stop();
    }
  }, {
    key: "runJob",
    value: function runJob() {
      var _this = this;

      cancelAnimationFrame(this.frame);
      var start = performance.now();
      var detectionThreshold = this.opts.detectionThreshold;
      this.frame = requestAnimationFrame(function () {
        var end = performance.now();
        var span = end - start;

        if (span > detectionThreshold) {
          _this.log({
            t: 'perf',
            c: 10490,
            d: span
          });
        }
      });
    }
  }]);

  return Task;
}();

var uiBlockDetectionTask = function uiBlockDetectionTask(log) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Task(log, opts);
};

export default uiBlockDetectionTask;